@if (visible$ | async) {
  <div class="dmp-spinner-overlay" role="status" aria-live="polite" aria-busy="true">
    <div class="dmp-spinner-overlay__panel">
      <span class="dmp-spinner-overlay__ring" aria-hidden="true"></span>
      <span class="dmp-spinner-overlay__label">Processing…</span>
    </div>
  </div>
}
